import HttpClientToken from '../../services/HttpClientToken';

import { defaultSubTipoAcuerdo, SubTipoAcuerdoProps } from '../../interfaces/catalogos/SubTipoAcuerdoInterface';

export const SubTipoAcuerdos = () => {

    return new Promise<SubTipoAcuerdoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/SubTipoAcuerdo/', token)
            .then( ({ data } : { data : SubTipoAcuerdoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        } else {
            resolve( [] );
        }

    });

}

export const ObtenerSubTipoAcuerdos = () => {

    return new Promise<SubTipoAcuerdoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/SubTipoAcuerdo/ObtenerSubTipoAcuerdos', token)
            .then( ({ data } : { data : SubTipoAcuerdoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        } else {
            resolve( [] );
        }

    });

}

export const ObtenerSubTipoAcuerdo = ( id: number ) => {

    return new Promise<SubTipoAcuerdoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/SubTipoAcuerdo/ObtenerSubTipoAcuerdo/${ id }`, token)
            .then( ({ data } : { data : SubTipoAcuerdoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        } else {
            resolve( [] );
        }

    });

}

export const ActualizarSubTipoAcuerdo = ( params: SubTipoAcuerdoProps ) => {

    return new Promise<SubTipoAcuerdoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/SubTipoAcuerdo/Actualizar', params, token)
            .then( ({ data } : { data : SubTipoAcuerdoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultSubTipoAcuerdo } );
            });

        }

    });

}

export const AgregarSubTipoAcuerdo = ( params: SubTipoAcuerdoProps ) => {

    return new Promise<SubTipoAcuerdoProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/SubTipoAcuerdo/Agregar', params, token)
            .then( ({ data } : { data : SubTipoAcuerdoProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultSubTipoAcuerdo } );
            });

        }

    });

}
